/* eslint-disable @typescript-eslint/naming-convention */
import type { IInfinitePatientsResponse } from "../../types";

import classes from "./styles.module.scss";

import type { IMetaOption } from "@/interfaces";
import { Avatar } from "@/components/atoms/avatar";
import { Typography } from "@/components/atoms/typography";
import { Icon } from "@/components/atoms/icons";

export function PatientItem(props: IMetaOption<IInfinitePatientsResponse>) {
  const {
    avatar,
    birthday,
    first_name,
    last_name,
    national_id,
    user_id,
    value,
  } = props;

  return (
    <div className={classes.card}>
      <Avatar
        size={"small"}
        userInfo={{
          firstName: first_name,
          lastName: last_name,
          imageUrl: avatar?.url,
        }}
        variant={44}
      />
      <div className={classes.cardText}>
        <div className={classes.cardTopRow}>
          <Typography
            fontWeight={"semi-bold"}
            fontFamily={"dana"}
            fontSize={"md-high"}
          >
            {value}
          </Typography>
          {user_id && (
            <Typography
              fontFamily={"dana"}
              fontSize={"xs"}
              variant={"caption1"}
            >
              {user_id}
            </Typography>
          )}
        </div>
        <div className={classes.cardTopRow}>
          <div>
            <Typography fontSize={"sm"} color={"secondary-text"}>
              {national_id}
            </Typography>
          </div>
          <div className={"d-flex align-items-center gap-xs1"}>
            <Icon name={"Calendar"} fontSize={"md"} color={"secondary-text"} />
            <Typography
              fontFamily={"dana"}
              fontWeight={"regular"}
              variant={"caption1"}
            >
              {birthday}
            </Typography>
          </div>
        </div>
      </div>
    </div>
  );
}
